var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mb-0",attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v(" Let op vertrouwelijke informatie. Niet delen met onbevoegden. ")])}
var staticRenderFns = []

export { render, staticRenderFns }